<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="900px"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>更多详情</span>
    </div>
    <template>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          class="tabs"
          label="模拟量"
          name="first"
        >
          <analogXINGHENG
            :data.sync="analogData"
            v-if="type === 'XINGHENG'"
          />
          <analogBETTER
            :data.sync="analogData"
            v-if="type === 'BETTER'"
          />
          <analogDALI
            :data.sync="analogData"
            v-if="type === 'DALI'"
          />
          <analogHERCULES
            :data.sync="analogData"
            v-if="type === 'HERCULES' || type === '01A' || type === 'SUNWODA'"
          />
        </el-tab-pane>
        <el-tab-pane
          class="tabs"
          label="告警量"
          name="second">
          <alarmXINGHENG
            :data.sync="alarmData"
            v-if="type === 'XINGHENG'"
          />
          <alarmBETTER
            :data.sync="alarmData"
            v-if="type === 'BETTER'"
          />
          <alarmDALI
            :data.sync="alarmData"
            v-if="type === 'DALI'"
          />
          <alarmHERCULES
            :data.sync="alarmData"
            v-if="type === 'HERCULES' || type === '01A' || type === 'SUNWODA'"
          />
        </el-tab-pane>
        <el-tab-pane
          class="tabs"
          label="规格数据"
          name="third"
          v-if="type === '01A'"
        >
          <BaseInfo
            :data.sync="SpecificationData"
          />

        </el-tab-pane>
      </el-tabs>

    </template>
  </el-dialog>
</template>
<script>
import alarmXINGHENG from "./alarmXINGHENG.vue";
import analogXINGHENG from "./analogXINGHENG.vue";
import alarmBETTER from "./alarmBETTER.vue";
import analogBETTER from "./analogBETTER.vue";
import alarmHERCULES from "./alarmHERCULES.vue";
import alarmDALI from "./alarmDALI.vue";
import analogDALI from "./analogDALI.vue";
import analogHERCULES from "./analogHERCULES.vue";
import BaseInfo from "./baseInfo.vue";

export default {
  components: {
    analogXINGHENG,
    alarmXINGHENG,
    alarmBETTER,
    analogBETTER,
    alarmHERCULES,
    analogHERCULES,
    BaseInfo,
    alarmDALI,
    analogDALI
  },
  data() {
    return {
      activeName: "first",
      analogData: null,
      alarmData: null,
      SpecificationData: null,
    };
  },
  props: {
    type: {
      type: String
    },
    visible: {
      type: Boolean,
      default: false
    },
    batteryData: {
      type: Object
    }
  },
  watch: {
    batteryData: {
      handler(val) {
        // console.log(this.type, "type");
        // console.log(val, "data----------------------");
        if (!val) return;
        if (this.type === "XINGHENG") {
          this.analogData = val.mockPile ? val.mockPile : {};
          this.alarmData = val.warnPile ? val.warnPile : {};
        } else if (this.type === "BETTER") {
          this.analogData = val || {};
          this.alarmData = val || {};
        }else if(this.type === "DALI"){
            console.log("DALI")
        }else if(this.type === "HERCULES" || this.type == 'SUNWODA'){
            this.analogData = val.analog || {};
            this.alarmData = val.alarm || {};
        }else if(this.type === "01A"){
            this.analogData = val.analog || {};
            this.alarmData = val.alarm || {};
            this.SpecificationData = val.baseInfo || {};
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClick() {}
  }
};
</script>
<style lang="scss" scoped>
.tabs {
  max-height: 600px;
  overflow-y: auto;
  @include scrollBar;
}
::v-deep .el-dialog__body {
  padding: 15px 20px !important;
}
::v-deep .el-dialog__headerbtn {
  top: 12px;
}
// ::v-deep .el-dialog__header{
//   background-color: #F6F6F6;
//   padding: 25px 20px 10px;
// }
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
